import React, { useEffect, useState } from 'react'
import './index.scss'
// import Header from '@/components/header'
import { getLocationSearch } from '@/utils/utils'


import { connect } from 'react-redux'
const mapStateToProps = (state) => ({
  tenant: state.getIn(['tenantReducer', 'tenant']),
})
const InviteVideo = (props) => {
  //获取token
  let getToken = getLocationSearch().token

  //拿到每个出行平台的唯一标识符
  let cxname = props.tenant;
  let { history } = props
  // 教学视频
  let { videoUrl } = props.match.params
  videoUrl = decodeURIComponent(videoUrl)


  useEffect(() => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android
    if (isAndroid) {
      // window.handleGoBack();//这里的.android是安卓那边定义的类,可以随便定义,但这里必须要跟安卓那边统一
      if(typeof window?.savePicture?.setTitle === 'function'){
        window?.savePicture?.setTitle('教学视频')
      }
    }
    window.document.title='教学视频'
    return () => {
    }
  }, [])
  return (
    <div className='video_box'>
      <div className='iframe_box' dangerouslySetInnerHTML={{ __html: videoUrl }} />
    </div>

  )
}
export default connect(mapStateToProps)(InviteVideo)
